var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragHandle = function SvgDragHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 22 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H7v2h2zM9 21H7v2h2zM9 9H7v2h2zM15 15h-2v2h2zM15 21h-2v2h2zM15 9h-2v2h2z"
  })));
};
export default SvgDragHandle;